import '@take-2/fd-modules/theater/showtimes/desktop.app';
